import React,{ useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Notice from "../../partials/content/Notice";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import Autocomplete from '@material-ui/lab/Autocomplete';

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import CodeExample from "../../partials/content/CodeExample";
import { getInventories,getUsersWoP,getMenus,getRoles,getAccountDetails, getMyAccounts, getMaster,getLocations,updateMaster,getStatus,getScheduleByKey, getProcedureTypes} from "../../crud/auth.crud";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import { Tooltip } from "@material-ui/core";  
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';




const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
     // margin: theme.spacing(1),
      minWidth: 120,
    },
};





class EditSchedule extends React.Component {
  state = {
    fields:[],
    users:[],
    roles:[],
    accounts:[],
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    schedule:{},
    tasktypes:[],
    mStatus:[],
    permission:[],
    schProcedureAccountKey:[],
    selectedVal:[],
    implants:[],
    lotNumbers:[],
    lotNumber:'',
    batchNumbers:[],
    batchNumber:'',
    lotNumberSel:[],
    batchNumberSel:[],
    batchNumberDefault:[],
    lotNumberDefault:[],
    locations:[],
    procedureTypes:[],
    inventories:[],
    selInventories:[],
    description:''
    
  }





constructor(props)
{
  super(props);
  var date = new Date();
  let batchNumbers =[];
  let lotNumbers=[];

if (this.props.location!=null && this.props.location.data!=null)  
{
    console.log("props-data::schedule::::",this.props.location.data);
}
else if(props.schedule!=null)
{
  console.log("props::schedule::::",props.schedule);
  batchNumbers = props.schedule.batchNumbers;
  lotNumbers = props.schedule.lotNumbers;
}

  
  
    this.state = {
      menu: false,
      fields:[],
      roles:[],
      users:[],
      accounts:[],
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
     
      tasktypes:[],
      mStatus:[],
      permission:[],
      schProcedureAccountKey:[],
      selectedVal:[],
      implants:[],
      lotNumbers:lotNumbers,
      lotNumber:'',
      batchNumbers:batchNumbers,
    batchNumber:'',
    lotNumberSel:[],
    batchNumberSel:[],
    batchNumberDefault:[],
    lotNumberDefault:[],
    locations:[],
    procedureTypes:[],
    inventories:[],
    selInventories:[],
    description:''
   
    };


    
  this.toggleMenu = this.toggleMenu.bind(this);
  //this.handleClick = this.handleClick.bind(this);
}
  
  onSelectLotNumber=(e, value)=> {

let selected='';
  let sel=[];
  if(value!=null)
  {
    value.map((grp)=>(
      selected = grp.lotNumber ,
      sel.push(selected)
      ))
    this.setState({
      lotNumber: selected,lotNumberSel:sel
    })
  }
  
 console.log("tags",selected);
}
onSelectBatchNumber=(e, value)=> {

let selected='';
  let sel =[];
  if(value!=null)
  {
    value.map((grp)=>(
      selected = grp.batchNumber ,
      sel.push(selected)
      ));
    this.setState({
      batchNumber: selected,batchNumberSel:sel
    });


  }
  
 console.log("tags",selected);
}

addBatchNumber=()=>
{
    
    console.log("ggggg");
    let selected = this.state.batchNumberSel;
    let batchNumbers = [];
    let batchNumber = '';
    if(this.state.batchNumber!=null && this.state.batchToothNumber!==undefined && this.state.batchToothNumber!==null && this.state.batchToothNumber!=='')
    {
      batchNumber = this.state.batchToothNumber + " - " + this.state.batchNumber;
      selected.push(batchNumber);

      if(this.state.batchNumbers!=null)
        batchNumbers = this.state.batchNumbers;
      batchNumbers.push({batchNumber:this.state.batchToothNumber + " - " + this.state.batchNumber});
    }
    else if(this.state.batchNumber!=null && (this.state.batchToothNumber===undefined || this.state.batchToothNumber===''))
    {
      batchNumber = this.state.batchNumber;
      selected.push(batchNumber);
      if(this.state.batchNumbers!=null)
        batchNumbers = this.state.batchNumbers;
      batchNumbers.push({batchNumber:this.state.batchNumber});
    }
    
    this.setState({batchNumbers:batchNumbers,batchNumber:'',batchNumberSel:selected,batchToothNumber:''});
}

addLotNumber=(inventoryKey)=>
{
    
    console.log("ggggg");
     let selected = this.state.lotNumberSel;
    let lotNumbers = [];
    let lotNumber = '';
    let inventories =this.state.selInventories;
    if(this.state.lotNumber!==null  && this.state.lotToothNumber!==undefined && this.state.lotToothNumber!==null  && this.state.lotToothNumber!=='')
    {
      lotNumber = this.state.productName+ "/" +this.state.lotNumber + "/#"+this.state.lotToothNumber;
      console.log("1lot number:::",lotNumber);
      console.log("lotnumber selected:::",this.state.lotNumberSel);
      if(this.state.lotNumber!=='')
        selected.push(lotNumber);

      if(inventoryKey!=null)
      {
        inventories.push(inventoryKey);
        this.setState({selInventories:inventories})
      }

      if(this.state.lotNumbers!==null)
        lotNumbers = this.state.lotNumbers;
      if(this.state.lotNumber!=='')
        lotNumbers.push({lotNumber:  this.state.productName+ "/" +this.state.lotNumber + "/#"+this.state.lotToothNumber });
    }
    else if(this.state.lotNumber!==null && (this.state.lotToothNumber===undefined || this.state.lotToothNumber===''))
    {
      lotNumber = this.state.lotNumber;
      console.log("2lot number:::",lotNumber);
      console.log("lotnumber selected:::",this.state.lotNumberSel);
      if(this.state.lotNumber!=='')
        selected.push(lotNumber);

      if(inventoryKey!=null)
      {
        inventories.push(inventoryKey);
      }

      if(this.state.lotNumbers!==null)
        lotNumbers = this.state.lotNumbers;
      if(this.state.lotNumber!=='')
        lotNumbers.push({lotNumber:this.state.lotNumber});
    }
    
    this.setState({lotNumbers:lotNumbers,lotNumber:'',lotNumberSel:selected,description:''});
}

onInputLotNumber=(e)=> {
  console.log("lotnumber",e);

    if(this.state.inventories!==null && this.state.inventories.length>0)
    {
      this.state.inventories.filter(x=>x.inventoryKey===e.target.value).map(inv=>{
         this.setState({
          lotNumber: inv.lotNumber, inventoryKey: inv.inventoryKey, productName : inv.description
        });
      })
    }
   
    console.log(e.target.value);
  }

  onInputBatchToothNumber=(e)=> {
    console.log("onInputBatchToothNumber",e);
      this.setState({
        batchToothNumber: e.target.value
      });
      console.log(e.target.value);
    }


     onInputLotProductName=(e, locationKey)=> {
      console.log("onInputLotProductName",e,this.state.schedule.locationKey);
        //this.setState({
        //  lotToothNumber: e.target.value
        //});
        if(e.target.value.length>4 )
        {
          let postObj={};
          if(locationKey!==null && locationKey!=="")
          {
            postObj = {
            locationKey : locationKey,
            searchDescription : e.target.value,
            cdnboolapprovedStatus: 'true'
            };
          
          
           //else{
            //postObj = {
          
           //   searchDescription : e.target.value};
          
          // }
           //console.log("search inventory::::",postObj);
              getInventories(1,50,'description','asc',postObj)//.then(response => response.data)
                    .then((response) => {
                      this.setState({ inventories: response.data });
               });	
           }
              //console.log(e.target.value);
          
        }
      }


    onInputLotToothNumber=(e)=> {
      console.log("onInputLotToothNumber",e);
        this.setState({
          lotToothNumber: e.target.value
        });
        console.log(e.target.value);
      }

  onInputBatchNumber=(e)=> {
    this.setState({
      batchNumber: e.target.value
    });
    console.log(e.target.value);
  }

  deleteBatchNumber=(e)=> {
    let batchNumbers  = this.state.batchNumbers;
    let index = batchNumbers.findIndex(x=>x.batchNumber===e);
    batchNumbers.splice(index,1);

    let batchNumberSel  = this.state.batchNumberSel;
    let index1 = batchNumberSel.findIndex(x=>x===e);
    batchNumberSel.splice(index1,1);


    this.setState({
      batchNumbers: batchNumbers,batchNumberSel:batchNumberSel
    });
    
  }

  deleteLotNumber=(e)=> {
    let lotNumbers  = this.state.lotNumbers;
    let index = lotNumbers.findIndex(x=>x.lotNumber===e);
    lotNumbers.splice(index,1);

    let lotNumberSel  = this.state.lotNumberSel;
    let index1 = lotNumberSel.findIndex(x=>x===e);
    lotNumberSel.splice(index1,1);

    this.setState({
      lotNumbers: lotNumbers,lotNumberSel:lotNumberSel
    });
  }


  toggleMenu(){
    this.setState({ menu: !this.state.menu })
  }

  async componentDidMount()
  {
    
    /*getFields().then(response => response.data)
    .then((data) => {
      this.setState({ fields: data[0].fields })
      //console.log(data[0].fields);
     //console.log(this.state.users)
     })
     */
     let schedule = {};
  if (this.props.location!=null && this.props.location.data!=null) 
  {
    schedule = this.props.location.data;
    this.setState({schedule:schedule,schdate: schedule.startDate});
    
  }
  else if(this.props.schedule!=null)
  {
    console.log("didmont:::props",this.props.schedule);

    let locations=[];
     schedule = this.props.schedule;
      let selectedVal = [];
                let tguser=[];
     if(schedule.schProcedureAccountKey!=null)
     {
       await getMaster('implant').then(response => response.data)
    .then((data) => {
       data.map((acc,i)=>
                          (
                            console.log("data1",acc.implantTypeKey,i),
                              schedule.schProcedureAccountKey.filter(a=> a == acc.implantTypeKey).map((mp)=>(
                                selectedVal.push(data[i]),
                                tguser.push(mp)
                              ))
                          ))
     //console.log(selectedVal)
     })
      }        
               // setVal(selectedVal);
                console.log("data",selectedVal);
               // setMappedAccounts(tguser);
               console.log(schedule);

      let batchNumbers = [];
      if(schedule.batchNumber!=null)
      {
        schedule.batchNumber.map((x)=>(
          batchNumbers.push({batchNumber:x})
        ))
      }
      console.log("batchnumbers::::",batchNumbers);

      let lotNumbers = [];
      if(schedule.lotNumber!=null)
      {
        schedule.lotNumber.map((x)=>(
          lotNumbers.push({lotNumber:x})
        ))
      }

      console.log("lotNumbers::::",lotNumbers);

     await getLocations(1,100,'locationName','asc',{accountKey:schedule.assignedToAccountKey})
      .then((response) => {
        //this.setState({ locations:response.data})
        locations = response.data;
        console.log("locations:::::",response.data);
       });
 

     this.setState({schedule:schedule,
      selectedVal:selectedVal,
      schProcedureAccountKey:tguser,
      schdate: schedule.startDate,
      lotNumberSel:schedule.lotNumber === null ? []: schedule.lotNumber,
      batchNumberSel:schedule.batchNumber === null? []: schedule.batchNumber,
      lotNumbers:lotNumbers,
      batchNumbers:batchNumbers,
      batchNumberDefault:batchNumbers,
      lotNumberDefault:lotNumbers,
      locations: locations

     })

  }
  else if(this.props.location.param!=null)
  {
    console.log("props pramaoooo::schedule::::",this.props.location.param);
    getScheduleByKey(this.props.location.param).then(response => response.data)
    .then((data) => {
      this.setState({schedule:data,schdate: schedule.startDate});
     // console.log(data);
     });
  }
     getStatus().then(response => response.data)
    .then((data) => {
      this.setState({ mStatus: data })
     // console.log(data);
     });

     getUsersWoP().then(response => response.data)
    .then((data) => {
      this.setState({ users: data })
      //console.log(this.state.users)
     })

     getRoles().then(response => response.data)
    .then((data) => {
      this.setState({ roles: data })
      //console.log(this.state.users)
     })

     getProcedureTypes().then(response => response.data)
    .then((data) => {
      //this.setState({ procedureTypes: data })
      let filtered=[];
      let procedureTypes =data;
       getAccountDetails().then(response => response.data)
      .then((data) => {
        console.log("prppp::",data);
        if(data.procedureTypes!=null)
        {
          data.procedureTypes.map((pt)=>(
            procedureTypes.filter(x=>x.procedureTypeKey===pt).map((p)=>(
                filtered.push(p)
              ))
            ))
        }
        console.log("filtered prtyy:::::",filtered);
        this.setState({ procedureTypes: filtered })
      //console.log(this.state.users)
      })

      //console.log(this.state.users)
     })

    getMaster("tasktype").then(response => response.data)
    .then((data) => {
      this.setState({ tasktypes: data })
      //console.log(this.state.users)
     })

    getMaster("implant").then(response => response.data)
    .then((data) => {
      this.setState({ implants: data })
      //console.log(this.state.users)
     })

    getMyAccounts().then(response => response.data)
    .then((data) => {
      this.setState({ accounts: data })
      //console.log(this.state.users)
     })

    getMenus().then(response => response.data)
    .then((data) => {
      
      if(data[0] != null && data[0].permissions !=null)
                {
                 
                  console.log(data[0].permissions);
                  let perms="";
                  data[0].permissions.map((per) =>(
                    perms = perms + "," + per
                    ))
                  console.log(perms);
                   this.setState({ permission: perms })

                }
     })
  }

onSelectTag=(e, value)=> {

let tguser=[];
  if(value!=null)
  {
    value.map((acc)=>(
      tguser.push(acc.implantTypeKey)
      ))
    console.log(tguser);
    this.setState({schProcedureAccountKey:tguser});
  }
}
handleClickDetails(user)
  {
    return function(){
      console.log('handleClickDetails');
           
    }

    
  
} 
accountChange = (e) =>
 {
      console.log("account chnage::::",e);

      getLocations(1,100,'locationName','asc',{accountKey:e.target.value})
      .then((response) => {
        this.setState({ locations:response.data})
        //console.log("patient by id::::",data);
       });
      

 }


  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;

     

    return (
      <>
          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

          {this.state.schedule != null &&

          <Formik
                  initialValues={{
                    accountId:this.state.schedule.accountId,
                    roleId:this.state.schedule.roleId,
                    userId:this.state.schedule.userId,
                    scheduleType:this.state.schedule.scheduleType,
                    pEntityId:this.state.schedule.pEntityId,
                    startDate:this.state.schedule.startDate,
                    endDate:this.state.schedule.endDate,
                    //notes:this.state.schedule.notes,
                    notes:'',
                    taskTypeId:this.state.schedule.taskTypeId,
                    assignedToAccountKey:this.state.schedule.assignedToAccountKey,
                    status: this.state.schedule.statusKey,
                    schProcedureAccountKey: this.state.schProcedureAccountKey,
                    addNotes1: this.state.schedule.addNotes1,
                    addNotes2: this.state.schedule.addNotes2,
                    lotNumber: this.state.schedule.lotNumber ===null?'':this.state.schedule.lotNumber,
                    batchNumber: this.state.schedule.batchNumber===null? '':this.state.schedule.batchNumber,
                    locationKey: this.state.schedule.locationKey,
                    procedureTypeKey: this.state.schedule.procedureTypeKey===null? '':this.state.schedule.procedureTypeKey,
                    
                    
                  }}
                  validate={values => {
                    const errors = {};

                   

                    if (!values.taskTypeId) {
                      errors.taskTypeId = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.accountId) {
                      errors.accountId = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    //batch num,lot number by sk request aug 14
                    /*if(values.status === 'STA00020')
                    {
                      if (this.state.lotNumberSel.length===0) {
                        errors.lotNumber = this.props.intl.formatMessage({
                          id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                      }

                      if (this.state.batchNumberSel.length===0) {
                        errors.batchNumber = this.props.intl.formatMessage({
                          id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                      }
                    }*/


                    //if (!values.notes) {
                    //  errors.notes = this.props.intl.formatMessage({
                    //    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                    //  });
                    //}

                   

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting }) => {

                   this.setState({loading:true});
                   let schedule = {
                      roleId: values.roleId,
                      userId: values.userId,
                      scheduleType: "",
                      pEntityId: this.state.schedule.pEntityId,
                      startDate:this.state.schdate,
                      endDate:values.endDate,
                      notes:values.notes,
                      taskTypeId: values.taskTypeId,
                      assignedToAccountKey: values.assignedToAccountKey,
                      accountId: this.state.schedule.accountId,
                      statusKey: values.status,
                      schProcedureAccountKey: this.state.schProcedureAccountKey,
                      addNotes1: values.addNotes1,
                      addNotes2:values.addNotes2,
                      lotNumber: this.state.lotNumberSel,
                      batchNumber:this.state.batchNumberSel,
                      locationKey: values.locationKey,
                      procedureTypeKey: values.procedureTypeKey,
                      inventories:this.state.selInventories,
                   };
                    updateMaster("schedule",this.state.schedule.scheduleId,schedule
                      )
                      .then(resp => {
                        //props.register(accessToken);
                       
                        this.setState({status:true,
                        statusMessage:'Schedule has been updated successfully',
                        alertType:'alert-success',loading:false});
                         window.scrollTo(0,0);
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
          
     
          <div className="kt-section">
            <div className="kt-section__content">
            

         
                      <div className="row">
                        <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="taskTypeId-label">Select To Do</InputLabel>
                             <Select
                              labelId="taskTypeId-label"
                              id="taskTypeId"
                              onChange={handleChange}
                              margin="normal"
                              name="taskTypeId"
                              value={values.taskTypeId}
                              
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                           
                              {this.state.tasktypes.map((ttp) =>(

                              
                                (ttp.taskTypeId === values.taskTypeId || !this.state.permission.includes("ALLOWEDTYPE"))&& <MenuItem key={ttp.taskTypeId} value={ttp.taskTypeId}>{ttp.taskTypeName}</MenuItem>
                                 
                              
                              ))}
                            </Select>
                         </FormControl>
                      </div>     
                       <div className="row">
                        <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="procedureTypeKey-label">procedure Type</InputLabel>
                             <Select
                              labelId="procedureTypeKey-label"
                              id="procedureTypeKey"
                              onChange={handleChange}
                              margin="normal"
                              name="procedureTypeKey"
                              value={values.procedureTypeKey}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                           
                              {this.state.procedureTypes!=null && this.state.procedureTypes.map((pt) =>(

                              
                                <MenuItem key={pt.procedureTypeKey} value={pt.procedureTypeKey}>{pt.procedureTypeName}</MenuItem>
                                 
                              
                              ))}
                            </Select>
                         </FormControl>
                      </div>        

                      <div className="row">
                       
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-around">
                        <KeyboardDatePicker
                              variant="inline"
                              format="MM/dd/yyyy"
                              margin="normal"
                              id="startDate"
                              name="startDate"
                              label="Task Date"
                              value={this.state.schdate}
                              onChange={value => {
                                this.setState({schdate:value})
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                          {/*<KeyboardTimePicker
          margin="normal"
          id="time-picker"
          label="Task Time"
          value={this.state.schdate}
          onChange={value => {
                                this.setState({schdate:value})
                              }}
          KeyboardButtonProps={{
            'aria-label': 'change time',
          }}
        />*/}
                        </Grid>
                        </MuiPickersUtilsProvider>
                      </div>      

                     
                     <div className="row">
                        <TextField
                          margin="normal"
                          label="Notes"
                          className="kt-width-full"
                          name="notes"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.notes}
                          helperText={touched.notes && errors.notes}
                          error={Boolean(touched.notes && errors.notes)}
                        />
                      </div>    
                      
             
              <div className="row">
                 <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="accountId-label">Assign To</InputLabel>
                             <Select
                              labelId="accountId-label"
                              id="assignedToAccountKey"
                              onChange={handleChange}
                              margin="normal"
                              name="assignedToAccountKey"
                              value={values.assignedToAccountKey}
                              onChange={(e) => {handleChange(e);this.accountChange(e);}}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {this.state.accounts.map((acc) =>(

                              <MenuItem value={acc.accountId}>{acc.accountName +' (' + acc.businessEntity +')'}</MenuItem>
                              
                              ))}
                            </Select>
                         </FormControl>
              </div>

              <div className="row">
                 <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="locationKey-label">Location</InputLabel>
                             <Select
                              labelId="locationKey-label"
                              id="locationKey"
                              margin="normal"
                              name="locationKey"
                              value={values.locationKey}
                              //onChange={(e)=>{handleChange(e);this.setState({locationKey:e.target.value})}}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {this.state.locations.map((loc) =>(

                              <MenuItem key={loc.locationKey} value={loc.locationKey}>{loc.locationName}</MenuItem>
                              
                              ))}
                            </Select>
                         </FormControl>
              </div>

              {(this.state.permission!=null && !this.state.permission.includes("DENY:TASKASSIGNMENT") &&
              <div className="row">
                <FormControl className={classes.formControl} style={{'width':'100%'}}>
             
                          <InputLabel shrink id="roleId-label">Select Role</InputLabel>
                             <Select
                              labelId="roleId-label"
                              id="roleId"
                              onChange={handleChange}
                              margin="normal"
                              name="roleId"
                              value={values.roleKey}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                            {this.state.roles.map((role)=>(
                                role.roleName !== 'SASADMIN' &&
                                <MenuItem value={role.roleId}>{role.roleDescription}</MenuItem>
                                
                              ))}
                            
                            

                            </Select>
                        </FormControl>
              </div>
              )}
              {(this.state.permission!=null && !this.state.permission.includes("DENY:TASKASSIGNMENT") &&
              <div className="row">
                     <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="userId-label">Select User</InputLabel>
                             <Select
                              labelId="userId-label"
                              id="userId"
                              onChange={handleChange}
                              margin="normal"
                              name="userId"
                              value={values.userId}
                              
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                             {this.state.users.map((user)=>(
                               
                                <MenuItem value={user.userId}>{user.firstName + " "+ user.lastName }</MenuItem>
                              ))}
                            
                            

                            </Select>
                         </FormControl>
              </div>
              )}
              <div className="row">
                <TextField
                              labelId="status-label"
                              id="status"
                              margin="normal"
                              name="status"
                              value={values.status}
                              onChange={handleChange}
                              className="kt-width-full"
                              label="Select Status"
                              style={{'width':'100%'}}
                            select>
                              
                              {this.state.mStatus.map((status) =>(
                               
                                (this.state.permission.includes("ALLOWEDSTATUS:"+status.statusKey) || status.statusKey === values.status || !this.state.permission.includes("ALLOWEDSTATUS"))&& <MenuItem key={status.statusKey} value={status.statusKey}>{status.statusDescription}</MenuItem>
                                 
                                
                              ))}
                            </TextField>
              </div>
               {values.status==='STA00008' &&
               <div className="row">
                 

                          <Autocomplete
                            multiple
                            id="tags-standard"
                            defaultValue={this.state.selectedVal}
                            options={this.state.implants}
                            onChange={this.onSelectTag}
                            style={{'width':'100%'}}
                            getOptionLabel={(option) => option.implantName }
                            renderInput={(params) => (
                                      <TextField style={{'width':'100%'}}
                                      {...params}
                              
                                                                margin="normal"
                                                                label="Implant Name"
                                                                
                                                              />

                            )}
                          />
               
              </div>
            }
            
            {values.status==='STA00008' &&
              
                 
                 <div className="row">
                        <TextField
                          margin="normal"
                          label="Implant Type"
                          className="kt-width-full"
                          name="addNotes2"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.addNotes2}
                          helperText={touched.addNotes2 && errors.addNotes2}
                          error={Boolean(touched.addNotes2 && errors.addNotes2)}
                        />
                      </div>   
                        
               
              
            }
            {values.status==='STA00008' &&
              
                 
                  <div className="row">
                        <TextField
                          margin="normal"
                          label="Size"
                          className="kt-width-full"
                          name="addNotes1"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.addNotes1}
                          helperText={touched.addNotes1 && errors.addNotes1}
                          error={Boolean(touched.addNotes1 && errors.addNotes1)}
                        />
                      </div>   

                        
               
              
            }

            {values.status==='STA00020' &&
              <>
                 {values.locationKey ==="" &&
                        <p style={{'font-size': '10px','color': 'red'}}>Location is mandatory to fetch products</p>
                        
                        } 
                         {values.locationKey ===null &&
                        <p style={{'font-size': '10px','color': 'red'}}>Location is mandatory to fetch products</p>
                        
                        } 
                 <div className="row align-items-end">

                      <div className="col">
                        
                       <TextField
                          margin="normal"
                          label="Descripion"
                          className="kt-width-full"
                          name="productName"
                          onBlur={handleBlur}
                          onChange={(e)=>this.onInputLotProductName(e,values.locationKey)}
                          //disabled={this.state.inventoryKey!==null && this.state.inventoryKey!==''?false:true}
                          //value={values.description}
                          //helperText={touched.lotToothNumber && errors.lotToothNumber}
                          //error={Boolean(touched.lotToothNumber && errors.lotToothNumber)}
                          //error={this.state.inventoryKey!==null && this.state.inventoryKey!==''?false:true}
                          ///helperText={this.state.inventoryKey!==null && this.state.inventoryKey!==''? "" : "Location is mandatory"}
                           variant="filled"
                        />
                        
                      </div>
                      <div className = "col">
                          <TextField
                            select
                            id="lotNumber"
                              label="Lot Number"
                              margin="normal"
                              name="lotNumber"
                              //value = {this.state.lotNumber}
                              onChange={(e)=>this.onInputLotNumber(e,values.locationKey)}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                               variant="filled"
                          >
                              {this.state.inventories!==null && this.state.inventories.length>0 && this.state.inventories.map((loc) =>(

                              <MenuItem key={loc.inventoryKey} value={loc.inventoryKey}>{loc.lotNumber +'-'+ loc.description}</MenuItem>
                              
                              ))}
                              {this.state.inventories!==null && this.state.inventories.length===0 && 
                              <MenuItem value="">
                                <em>Only approved Scans listed here</em>
                              </MenuItem>
                              
                              }
                          </TextField>
                        </div>
                      
                      <div className="col">
                        
                       <TextField
                          margin="normal"
                          label="Tooth Number"
                          className="kt-width-full"
                          name="lotToothNumber"
                          onBlur={handleBlur}
                          onChange={this.onInputLotToothNumber}
                          //value={this.state.lotToothNumber}
                          helperText={touched.lotToothNumber && errors.lotToothNumber}
                          error={Boolean(touched.lotToothNumber && errors.lotToothNumber)}
                           variant="filled"
                        />
                      </div>
                      {/*<div className="col">
                        <TextField
                          margin="normal"
                          label="Lot Number"
                          className="kt-width-full"
                          name="lotNumber"
                          onBlur={handleBlur}
                          onChange={this.onInputLotNumber}
                          value={this.state.lotNumber}
                          helperText={touched.lotNumber && errors.lotNumber}
                          error={Boolean(touched.lotNumber && errors.lotNumber)}
                        />
                      </div>*/}
                      <div className="col">
                        <button type="button" className={"btn btn-primary small"} onClick={()=>this.addLotNumber(values.inventoryKey)}>Add </button>
                      </div>
                  
                        {/*<div className="col-lg-10">
                        <Autocomplete
                            multiple
                            id="lotNumber"
                             defaultValue={this.state.lotNumberDefault}
                            options={this.state.lotNumbers}
                            getOptionLabel={(option) => option.lotNumber}
                            onChange={this.onSelectLotNumber}
                            style={{'width':'100%'}}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                margin="normal"
                                label="Lot Number"
                                className="kt-width-full"
                                name="lotNumber"
                                multiLine
                                rows={4}
                                rowsMax={4}
                                onChange={this.onInputLotNumber}
                                value={this.state.lotNumber}
                                helperText={touched.lotNumber && errors.lotNumber}
                              error={Boolean(touched.lotNumber && errors.lotNumber)}
                              />

                            )}
                          />
                          </div>
                          <div className="col-lg-2 align-items-center">
                            <Tooltip
                                title="Add" 
                              ><AddCircleOutlineIcon style={{ color: '#5867dd',fontSize: 25}} onClick={()=>this.addLotNumber()} /></Tooltip>
                          </div>
                            */}

                      </div>   
                     
                   </>     
               
              
            }
            {this.state.lotNumbers!==null && this.state.lotNumbers.length>0 && this.state.lotNumbers.map((lot)=>(
                         <div className="row">
                           <div className="col">
                              {lot.lotNumber}
                            </div>
                            <div className="col">
                            <Tooltip
                                title="Delete" 
                              ><HighlightOffIcon style={{ color: '#5867dd',fontSize: 15}} onClick={()=>this.deleteLotNumber(lot.lotNumber)} /></Tooltip>
                            </div>
                          </div>
                      )
                      )

            }
            


              
        </div>
        </div>
       
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Update
                        </button>
                      </div>
              

        </form>
            )}
            </Formik>
          
      }

       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(EditSchedule));

